import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { withTranslation, WithTranslation } from 'react-i18next';
import { PapiBadge, PapiUser } from '@wix/da-types-papi';
import Badge from '@wix/da-shared-react/pkg/Badge';
import AddIcon from '@wix/da-shared-react/pkg/Icons/Add';
import { BiDiv, BiEventType } from '@wix/da-shared-react/pkg/biLogger';
import { actions as modalActions } from '@wix/da-shared-react/pkg/Modals';
import { AppState } from '../../../../../../../types/store';
import { getProfileOwnerUser } from '../../../../../../selectors/users';
import s from '../../BadgeBox/BadgeBox.scss';

export interface Props {
  item: PapiBadge;
  className?: string;
}

export interface ConnectedProps {
  profileOwnerUser?: PapiUser;
  pushBadgeModal: (
    name: 'llama' | 'cake',
    userId: number,
    title: string
  ) => void;
}

const enhance = compose(
  connect(
    (state: AppState) => ({
      profileOwnerUser: getProfileOwnerUser(state),
    }),
    {
      pushBadgeModal: modalActions.pushBadgeModal,
    }
  ),
  withTranslation()
);

class BadgeGiftBox extends React.Component<
  Props & ConnectedProps & WithTranslation
> {
  render() {
    const { item, className, pushBadgeModal, profileOwnerUser, t } = this.props;
    const title = t!('widgets.badgesbox.gift.give', { title: item.title });

    return (
      <div className={classnames(s['root'], s['gift'], className)}>
        <BiDiv
          className={s['flex']}
          onClick={() => {
            pushBadgeModal(
              item.name as 'llama' | 'cake',
              (profileOwnerUser && profileOwnerUser.userId) || 0,
              title
            );
          }}
          biData={{
            evid: BiEventType.GIFT_SELECT_CLICK,
            recipientid: profileOwnerUser && profileOwnerUser.useridUuid,
            menu_item_name: `give ${item.name} badge`,
          }}
        >
          <div className={s['badge-info']}>
            <AddIcon className={s['icon']} condensed withPadding />
            <Badge {...item} />
          </div>
          <div className={s['badge-title']}>
            <span className={s['badge-title-text']}>{title}</span>
          </div>
        </BiDiv>
      </div>
    );
  }
}

export default enhance(BadgeGiftBox) as React.ComponentType<Props>;
